import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    margin: '0 40px'
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF'
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  table: {
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '1000px',
      overflowX: 'auto'
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777'
    },
    '& .MuiSvgIcon-root': {
      fill: '#4B6FC2',
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px'
    },
    '& .MuiTableCell-paddingCheckbox': {
      width: '60px',
      padding: '0 10px'
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    },
    '& .indicator': {
      borderRadius: '10px',
      fontWeight: '500',
      fontSize: '12px',
      lineHeight: '15px',
      padding: '5px 10px',
      textTransform: 'capitalize',
      background: '#E1E1E1'
    },
    '& .indicator::before': {
      content: '\'\'',
      display: 'inline-block',
      width: '4px',
      height: '4px',
      borderRadius: '4px',
      margin: '0 4px 2px 0',
      background: '#848484',
      color: '#848484'
    },
    '& .processing.indicator::before': {
      background: '#CE8500'
    },
    '& .complete.indicator::before': {
      background: '#007F00'
    },
    '& .canceled.indicator::before': {
      background: '#848484'
    },
    '& .holded.indicator::before': {
      background: '#D30000'
    },
    '& .dispute.indicator::before': {
      background: '#ff573382'
    },
    '& .processing': {
      background: '#FFECCC',
      color: '#965E00'
    },
    '& .complete': {
      background: '#CDFFCD',
      color: '#007F00'
    },
    '& .canceled': {
      background: '#E1E1E1',
      color: '#848484'
    },
    '& .holded': {
      background: '#FFE0E0',
      color: '#D30000'
    },
    '& .dispute': {
      background: '#ff573382',
      color: '#FFFFFF'
    }
  },
  refundCard: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
  },
  refundTable: {
    '& .MuiTableCell-root': {
      fontSize: '12px',
      padding: '12px 8px',
      verticalAlign: 'top',
      paddingLeft: '20px',
      '& > div': {
        fontSize: '12px'
      }
    },
    '&.MuiPaper-rounded': {
      borderRadius: '8px'
    },
    '& .MuiTableCell-head': {
      padding: '12px 18px',
      '&.MuiTableCell-root:first-child': {
        paddingLeft: '28px'
      }
    }
  }
}));
